import { render } from "./ModalWrapper.3.vue?vue&type=template&id=2b4e12a4&scoped=true&ts=true"
import script from "./ModalWrapper.3.vue?vue&type=script&lang=ts"
export * from "./ModalWrapper.3.vue?vue&type=script&lang=ts"

import "./ModalWrapper.3.vue?vue&type=style&index=0&id=2b4e12a4&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4e12a4"]])

export default __exports__